module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', _vm._l((_vm.origins), function(origin) {
    return _c('li', [_c('div', {
      on: {
        "click": function($event) {
          _vm.setOrigin(origin)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": origin.img
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(origin.name))])])])
  })), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', [_vm._v("...or vote for your city to be the next origin.")]), _vm._v(" "), _c('form', [_c('input', {
    attrs: {
      "placeholder": "Your home city"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Vote")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c9cf3f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Origins.vue
// module id = 67
// module chunks = 1